import { useAppConfig } from 'Components/utils/AppBootstrapper/AppConfigContext';
import { DataLakeType } from 'Source/constants';
import useFeatureToggle from './useFeatureToggle';

const useCustomDashboardsEnabled = (): boolean => {
  const enableCustomDashboardsFeatureFlag = useFeatureToggle('ENABLE_CUSTOM_DASHBOARDS');
  const enablePantherflow = useFeatureToggle('ENABLE_PANTHERFLOW');
  const { pantherDataLakeType } = useAppConfig();
  const isSnowflake = (
    [
      DataLakeType.SnowflakeManaged,
      DataLakeType.SnowflakeConnected,
      DataLakeType.SnowflakeSelfHosted,
    ] as string[]
  ).includes(pantherDataLakeType);
  const isSupported =
    isSnowflake || (pantherDataLakeType === DataLakeType.Databricks && enablePantherflow);

  return enableCustomDashboardsFeatureFlag && isSupported;
};

export default useCustomDashboardsEnabled;
